import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "../utils/NotFound";
import Merchants from "../components/superadmin/merchant";
import SubscriptionList from "../components/superadmin/subscription";
import StoreAdmin from "../components/superadmin/storeadmin";

const SuperAdminRoute = () => {
  return (
    <>
      <React.Fragment>
        <Routes>
          <Route hidden path="/" element={<Merchants />} />
          <Route hidden path="/store-admin" element={<StoreAdmin />} />
          <Route hidden path="/subscription" element={<SubscriptionList />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Fragment>
    </>
  );
};

export default SuperAdminRoute;
